'use strict';

exports.__esModule = true;
exports.updateScrollTop = updateScrollTop;
var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
function updateScrollTop(scrollTop) {
  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-log-monitor/lib/actions.js
 ** module id = 238
 ** module chunks = 1
 **/